export const createMarkup = (markup: string) => {
  return { __html: markup };
};
